import Drawer from 'components/Drawer'
import React from 'react'
import EventDefaultImage from '../../../../../assets/images/EventDefaultImage.png'
import CloseIcon from '../../../../../components/icons/CloseIcon'
import EventPreviewContent from '../EventPreviewContent'
import { CloseBannerContainer, containerStyle } from './style'

const EventPreview = ({
  open,
  onClose,
  header,
  categoryBasedObj,
  data,
  handleClick,
  handleRegistrationClick,
}) => {
  const content = () => {
    return (
      <>
        <div style={containerStyle}>
          <CloseBannerContainer onClick={() => onClose()}>
            <CloseIcon />
          </CloseBannerContainer>
          {data?.banner?.url ? (
            <img
              src={data?.banner?.url}
              alt="Drawer Content"
              style={{ width: '100%', height: '200px' }}
            />
          ) : (
            <img
              src={EventDefaultImage}
              alt="Drawer Content"
              style={{ width: '100%', height: '200px' }}
            />
          )}
        </div>
        <EventPreviewContent
          categoryBasedObj={categoryBasedObj}
          data={data}
          handleClick={handleClick}
          handleRegistrationClick={handleRegistrationClick}
          open={open}
        />
      </>
    )
  }

  return (
    <Drawer
      width="600px"
      placement="right"
      padding="-30px"
      closable
      onClose={onClose}
      visible={open}
      content={content()}
      footer={null}
      isBanner={true}
      isHeader={header}
      bodyHeight={'100%'}
    />
  )
}

export default EventPreview
